jQuery(document).ready(function ($) {
  const slickSlider = $(".testimonial-slider__slides");
  const dotsContainer = $(".testimonial-slider .slick-dots-custom");

  // Initialize the slider
  slickSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".testimonial-slider .slick-prev"),
    nextArrow: $(".testimonial-slider .slick-next"),
    centerMode: true,
    centerPadding: "0",
  });

  // Add 'slick-active' class to the first dot when slider initializes
  dotsContainer.find(".slick-dot").eq(0).addClass("slick-active");

  // Add event listener for after slide change
  slickSlider.on("afterChange", function (event, slick, currentSlide) {
    // Remove 'slick-active' class from all dots
    dotsContainer.find(".slick-dot").removeClass("slick-active");
    // Add 'slick-active' class to the dot corresponding to the current slide
    dotsContainer
      .find('.slick-dot[data-slick-index="' + currentSlide + '"]')
      .addClass("slick-active");
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/layout/testimonials.js